import React from "react"
import PropTypes from "prop-types"
import monitaur from "../images/monitaur-390.png";
import pumpjackjpg from "../images/pumpjack.jpg";
import SmartBox from "../images/smartbox.jpg";
import InstrumentClose from "../images/instrumentclose.jpg"
import SolarPower from "../images/solar.jpg"
import { Link } from "gatsby"

const FrontPageContent = ({ siteTitle, menuLinks }) => (
<div>
<div className="tile is-ancestor">
  <div className="tile is-vertical">
    <div className="tile">
      <div className="tile is-parent is-3">
        <article className="tile is-child">
          <h2 className="welcome title has-text-weight-bold">Monitaur<br></br>
          <span className="sub">Technologies Incorporated</span></h2>
          <p className="welcome">We are an innovator in providing modern technology and automation to the Oil &amp; Gas industry. Utilising kubernetes to build highly available clusters to provide a very resilient listening mechanism ensuring that you don't miss critical incoming data. This coupled with modern visualizers, ensures that you have the critical knowledge to automate your business.  Monitaur provides the infrastructure, hardware, and management of remote monitoring of tank batteries, flow meters, pressure meters, pumps, and many other assets. Monitaur’s Remote Monitoring and Control Unit aka the Smartbox is a portable unit that can be used to simultaneously monitor numerous devices.</p>
        </article>
      </div>
      <div className="tile is-parent is-9">
          <img src={pumpjackjpg} style={{ width: "650px", height: "488px", alignItems: 'center', justifyContent: 'center', marginLeft: 'auto', marginRight: 'auto', display: 'flex' }} alt="Remote Monitoring Systems"></img>
      </div>
    </div>
  </div>
</div>
    <div className="tile is-ancestor">
    <div className="tile is-parent is-4">
        <div className="boxgrid caption tile is-child ">
          <Link to="/contact" >
            <img src={SmartBox} alt="Oil Field Smart box"></img>
          <div className="cover boxcaption" style={{ top: 200 + 'px' }} >
            <h3>Oil Field Smart Box<br></br>
            <span className="sub">&nbsp;</span></h3>
            <p>Tracking and Protecting of Assets</p>
            <div id="divide-lm110"></div>
            <div id="learnmorebtn">
              <Link to="/contact" className="rollover" title="click here to learn more">
               learn more
              </Link>
            </div>
          </div>
          </Link>
      </div>
    </div>

    <div className="tile is-parent is-4">
        <div className="boxgrid caption tile is-child ">
          <Link to="/contact" >
            <img src={InstrumentClose} alt="InstrumentClose"></img>
            <div className="cover boxcaption" style={{ top: 200 + 'px' }} >
            <h3>Tank Gauge<br></br>
            <span className="sub">&nbsp;</span></h3>
            <p>Monitor Tank Levels</p>
            <div id="divide-lm110"></div>
            <div id="learnmorebtn">
              <Link to="/contact" className="rollover" title="click here to learn more">
               learn more
              </Link>
            </div>
          </div>
          </Link >
        </div>
      </div>

    <div id="homeblocks-right" className="tile is-parent is-4">
        <div className="boxgrid caption tile is-child ">
          <Link to="/contact" >
            <img src={SolarPower} alt="Solar Power"></img>
            <div className="cover boxcaption">
            <h3>Solar Power<br></br>
            <span className="sub">&nbsp;</span></h3>
            <p>Solar Power of Oil Field Gear</p>
            <div id="divide-lm110"></div>
            <div id="learnmorebtn">
              <Link to="/contact" className="rollover" title="click here to learn more">
               learn more
              </Link>
            </div>
          </div>
          </Link >
        </div>
      </div>
    <div className="clear"></div>
  </div>
</div>
)

FrontPageContent.propTypes = {
  siteTitle: PropTypes.string,
}

FrontPageContent.defaultProps = {
  siteTitle: ``,
}

export default FrontPageContent
